// extracted by mini-css-extract-plugin
module.exports = {"Modal":"CustomModal-module--Modal--3FHVI","ModalBody":"CustomModal-module--ModalBody--d0vVe","ModalFooter":"CustomModal-module--ModalFooter--XJUsR"};